import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import { getMatchingSelectData, runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataCols, DataColumnRecord } from "../../input/inputType";
import { enLocale } from "@/i18n/routing";
import { listEditClickCommon } from "../../data/list/list";
export const RoasterGreenbean = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;

  const setSellerLink = (select_data: any) => {
    const temp_link_function = formFunction?.current.greenbean_seller_link;
    Debug(select_data);
    form?.current?.setFieldValue("greenbean_seller_link", select_data?.company_shop ?? "");
    if (temp_link_function && temp_link_function["setLinkValue"]) temp_link_function["setLinkValue"](select_data?.company_shop ?? "");
  };
  const linkInit = () => {
    const temp_seller_function = formFunction?.current.greenbean_seller_seq;
    if (temp_seller_function && temp_seller_function["selectData"]) {
      const select_data = temp_seller_function["selectData"]();
      Debug(select_data);
      setSellerLink(select_data);
    }
  };

  const defaultCols = (year?: boolean): DataColumnRecord => {
    return {
      greenbean_seller_seq: {
        ...dc.selectSearch,
        read: { show: "notNull" },
        //update: { disabled: true },
        dataUrl: "/api/code/company",
        dataProp: {
          fixedParam: { company_type: "GBD" },
          requiredParam: ["company_type"],
          load: (data, select_data) => {
            setSellerLink(select_data);
            // setTimeout(() => {
            // }, 100);
          },
          userAuth: false,
        },
        dataLabel: {
          value: "company_seq",
          label: [
            { field: "company_nick_locale", subs: "company_nick" },
            { field: "company_name_locale", subs: "company_name" },
          ],
          labelSort: true,
        },
        inputClassName: dc.inputCountryClassName,
        inputDirect: { target: "greenbean_seller_etc", query: ".greenbean_seller_etc_item" },
        onChange: (data) => {
          const temp_seller_function = formFunction?.current.greenbean_seller_seq;
          if (temp_seller_function) {
            const select_data = temp_seller_function["selectData"]();
            setSellerLink(select_data);
          }
        },
        selectChangeLoad: ["greenbean_default_seq"],
        //clearProp: { clearButton: true },
      },
      greenbean_seller_etc: {
        ...dc.inputFull,
        itemClassName: "greenbean_seller_etc_item",
        minLength: 3,
        maxLength: 1000,
        showCount: true,
        label: "blank",
        labelClassName: dc.mobileHidden,
        placeholder: "greenbean_seller_seq",
      },

      greenbean_country_code: {
        ...dc.coffee_country_feat,
        update: { disabled: true },
        selectChangeLoad: ["greenbean_region_seq", "greenbean_farm_seq", "greenbean_default_seq"],
      },

      greenbean_default_seq: {
        ...dc.selectSearch,
        update: { disabled: true },
        inputClassName: dc.inputCountryClassName,
        widthFull: true,
        selectFieldFilter: { greenbean_country_code: "greenbean_country_code" },
        dataUrl: "/api/code/greenbean/default",
        dataProp: {
          requiredParam: ["greenbean_seller_seq"],
          valueParam: { greenbean_seller_seq: "greenbean_seller_seq" },
          load: (data, select_data) => {
            Debug(data, select_data);
          },
          userAuth: false,
        },
        dataLabel: {
          value: "greenbean_default_seq",
          label: [
            params?.locale === enLocale
              ? { field: "greenbean_name", subs: "greenbean_nick" }
              : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
          ],
          labelSort: true,
        },
        onChange: (data) => {
          // const selectData = runFormFunction(formFunction?.current, "greenbean_default_seq", "selectData");
          // Debug(selectData, formMemo?.current["greenbean_default_seq"]);
          const result = getMatchingSelectData(form?.current, formFunction?.current, formMemo?.current, "greenbean_default_seq", [
            "greenbean_default_seq",
            "greenbean_country_seq",
            "greenbean_seller_seq",
            "greenbean_use",
            "edit_at",
          ]);
          //Debug(result);
          form?.current?.setFieldsValue(result);
          setTimeout(() => {
            runFormFunction(formFunction?.current, ["greenbean_region_seq", "greenbean_farm_seq"], "changeLoad");
          }, dc.setTimeoutShort);
          //greenbean_region_seq, greenbean_farm_seq
        },
      },

      greenbean_name_locale: {
        ...dc.inputFull,
        labelClassName: dc.strongLabelClassName,
        required: true,
        minLength: 3,
        maxLength: 300,
        showCount: true,
      },
      greenbean_name: {
        ...dc.inputFull,
        labelClassName: dc.strongLabelClassName,
        required: true,
        minLength: 3,
        maxLength: 300,
        showCount: true,
      },
      greenbean_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true },
      greenbean_nick: { ...dc.inputFull, maxLength: 300, showCount: true },

      greenbean_seller_link: {
        ...dc.link,
        copyProp: { copyButton: true },
        linkPropOption: { newTab: true },
        minLength: 3,
        maxLength: 300,
        showCount: true,
        readOnly: true,
        //readInput: true,
        noItem: false,
        saveData: false,
        //read: { display: "notNull" },
      },

      //greenbean_importer_seq: dc.number,
      //greenbean_country_seq: dc.number,
      greenbean_region_seq: {
        ...dc.selectSearch,
        read: { show: "notNull" },
        inputClassName: dc.inputCountryClassName,
        selectPropOption: { reloadButton: true },
        selectChangeLoad: "greenbean_farm_seq",
        inputDirect: { target: "greenbean_region_etc", query: ".greenbean_region_etc_item" },
        dataUrl: "/api/code/region",
        dataProp: {
          fixedParam: { is_parent: false },
          valueParam: { region_country: "greenbean_country_code" },
          requiredParam: ["region_country"],
          userAuth: false,
        },
        dataLabel: {
          value: "region_seq",
          label: [
            { field: "region_name_locale", subs: "region_nick_locale" },
            { field: "region_name", subs: "region_nick" },
          ],
        },
      },
      greenbean_region_etc: {
        ...dc.inputFull,
        itemClassName: "greenbean_region_etc_item",
        maxLength: 300,
        showCount: true,
        label: "blank",
        labelClassName: dc.mobileHidden,
        placeholder: "greenbean_region_seq",
      },
      greenbean_farm_seq: {
        ...dc.selectSearch,
        read: { show: "notNull" },
        inputClassName: dc.inputCountryClassName,
        inputDirect: { target: "greenbean_farm_etc", query: ".greenbean_farm_etc_item" },
        dataUrl: "/api/code/farm",
        dataProp: {
          valueParam: { region_country: "greenbean_country_code", farm_region_seq: "greenbean_region_seq" },
          requiredParam: ["region_country"],
          userAuth: false,
        },
        dataLabel: {
          value: "farm_seq",
          label: ["farm_name_locale", "farm_name"],
          labelSort: false,
        },
      },
      greenbean_farm_etc: {
        ...dc.inputFull,
        itemClassName: "greenbean_farm_etc_item",
        maxLength: 300,
        showCount: true,
        label: "blank",
        labelClassName: dc.mobileHidden,
        placeholder: "greenbean_farm_seq",
      },

      //greenbean_variety: { ...dc.variety, selectProp: { inputDirect: "greenbean_variety_etc" } },
      greenbean_variety_list: {
        ...dc.varietyMultiFeat,
        inputDirect: { target: "greenbean_variety_etc", query: ".greenbean_variety_etc_item" },
        read: {
          onClick: dc.clickDefault(
            (e: any) => {
              //alert(e);
            },
            () => {
              //alert("해당 품종에 대한 정보가 없습니다.");
            },
          ),
        },
      },
      greenbean_variety_etc: {
        ...dc.inputFull,
        itemClassName: "greenbean_variety_etc_item",
        minLength: 3,
        maxLength: 1000,
        showCount: true,
        label: "blank",
        labelClassName: dc.mobileHidden,
        placeholder: "greenbean_variety_list",
      },
      greenbean_grade: { ...dc.gradeFeat },
      greenbean_grade_detail: { ...dc.gradeDetailFeat },
      greenbean_process: { ...dc.process, inputDirect: { target: "greenbean_process_etc", query: ".greenbean_process_etc_item" } },
      greenbean_process_etc: {
        ...dc.inputFull,
        itemClassName: "greenbean_process_etc_item",
        minLength: 3,
        maxLength: 1000,
        showCount: true,
        label: "blank",
        labelClassName: dc.mobileHidden,
        placeholder: "greenbean_process",
      },

      greenbean_detail_explain: {
        label: "blank",
        labelClassName: dc.mobileHidden,
        fieldId: {
          greenbean_detail_min: {
            valueType: "number",
            type: "number",
            inputClassName: dc.greenbeanMinMaxWidth + " text-last",
            placeholder: "min_value",
            disabled: true,
            readOnly: true,
            variant: "borderless",
            noItem: true,
            //clearProp: { clearButton: true },
          },
          greenbean_detail_max: {
            valueType: "number",
            type: "number",
            inputClassName: dc.greenbeanMinMaxWidth + " text-last",
            placeholder: "max_value",
            disabled: true,
            readOnly: true,
            variant: "borderless",
            noItem: true,
            //clearProp: { clearButton: true },
          },
        },
      },

      altitude: {
        fieldId: {
          greenbean_altitude_min: {
            ...dc.altitude,
            inputClassName: dc.greenbeanMinMaxWidth + " text-last",
            //clearProp: { clearButton: true },
          },
          greenbean_altitude_max: {
            ...dc.altitude,
            inputClassName: dc.greenbeanMinMaxWidth + " text-last",
            read: { display: ["notNull", { greenbean_altitude_min: "notEquals" }] },
          },
        },
      },
      moisture: {
        fieldId: {
          greenbean_moisture_min: { ...dc.moisture, inputClassName: dc.greenbeanMinMaxWidth + " text-last" },
          greenbean_moisture_max: {
            ...dc.moisture,
            inputClassName: dc.greenbeanMinMaxWidth + " text-last",
            read: { display: ["notNull", { greenbean_moisture_min: "notEquals" }] },
          },
        },
      },
      greenbean_density: {
        fieldId: {
          greenbean_density_min: { ...dc.density, inputClassName: dc.greenbeanMinMaxWidth + " text-last" },
          greenbean_density_max: {
            ...dc.density,
            inputClassName: dc.greenbeanMinMaxWidth + " text-last",
            read: { display: ["notNull", { greenbean_density_min: "notEquals" }] },
          },
        },
      },
      agtron: {
        fieldId: {
          greenbean_agtron_min: { ...dc.agtron, inputClassName: dc.greenbeanMinMaxWidth },
          greenbean_agtron_max: {
            ...dc.agtron,
            inputClassName: dc.greenbeanMinMaxWidth,
            read: { display: ["notNull", { greenbean_agtron_min: "notEquals" }] },
          },
        },
      },
      harvest: {
        fieldId: {
          greenbean_harvest_min: {
            ...(year ? dc.month : dc.monthSelectFn(params?.locale)),
            inputClassName: dc.greenbeanMinMaxWidth,
            dateProp: { nowButton: false },
          },
          greenbean_harvest_max: {
            ...(year ? dc.month : dc.monthSelectFn(params?.locale)),
            inputClassName: dc.greenbeanMinMaxWidth,
            dateProp: { nowButton: false },
            read: { display: ["notNull", { greenbean_harvest_min: "notEquals" }] },
          },
        },
      },
      roasting_recommended: {
        fieldId: {
          greenbean_roasting_min: { ...dc.agtron, inputClassName: dc.greenbeanMinMaxWidth },
          greenbean_roasting_max: {
            ...dc.agtron,
            inputClassName: dc.greenbeanMinMaxWidth,
            read: { display: ["notNull", { greenbean_roasting_min: "notEquals" }] },
          },
        },
      },
      greenbean_desc: { ...dc.textAreaDefault, maxLength: 10000, showCount: true },
      greenbean_user_auth: {
        ...dc.roasterAuth,
        inputClassName: dc.inputCountryClassName,
        label: "select_auth",
      },
      greenbean_use: dc.useDefault,
    };
  };
  const commonClipboard: ClipboardProp = {
    category: "Greenbean",
    exField: ["roaster_seq", "greenbean_roaster_seq"],
    load: (obj) => {
      runFormFunction(formFunction?.current, ["greenbean_region_seq", "greenbean_farm_seq", "greenbean_default_seq"], "changeLoad");
    },
  };

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"greenbean_roaster","system_table_pk":["roaster_seq","greenbean_roaster_seq"],"system_table_manual_increment":"greenbean_roaster_seq","system_table_page":"RoasterGreenbeanDefault","system_table_path":"roaster/greenbean/default","system_table_page_name":"RoasterGreenbeanDefault","system_table_auth":["SADMIN","ADMIN","USER","ROASTER"],"system_select_auth":["roaster"],"system_roaster_auth":"SAST","system_roaster_auth_field":["greenbean_user_auth"],"system_table_mapper":"roaster","system_table_detail_result":"detail_result","system_table_search_column":["greenbean_variety","greenbean_grade","greenbean_grade_detail","greenbean_country_code","greenbean_seller_seq"],"system_table_search_select":["greenbean_name_locale","greenbean_name","greenbean_nick_locale","greenbean_nick"],"system_table_order_column":["greenbean_country_code","greenbean_name_locale"],"system_table_default_name_column":"greenbean_name_locale","system_table_en_name_column":"greenbean_name","system_table_use_column":"greenbean_use"},
    //--info--"change":{"greenbean_variety_list":{"COLUMN_CODE_SELECT":"VRT"},"greenbean_grade":{"COLUMN_CODE_SELECT":"BGRD"},"greenbean_grade_detail":{"COLUMN_CODE_SELECT":"BQLT"}}
    //--info--}
    case "RoasterGreenbeanDefault":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/greenbean/default/detail/", saveFetch: { fetchUrl: "/api/roaster/greenbean/default/edit" } },
        listFetch: { fetchUrl: "/api/roaster/greenbean/default/list" },
        dataResultName: "detail_result",
        dataName: "RoasterGreenbeanDefaultData",
        dataInit: (data: any) => {
          linkInit();
        },
        dataCols: { ...defaultCols(), ...dc.userInfoCols },
        clipboard: commonClipboard,
        listColLinkField: "greenbean_roaster_seq",
        listSearch: [
          {
            ...dc.process,
            codeGroupLabel: undefined,
            field: "search0",
            label: "greenbean_process",
            placeholder: "greenbean_process",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
          {
            ...dc.variety,
            codeGroupLabel: undefined,
            field: "search1",
            label: "greenbean_variety_list",
            placeholder: "greenbean_variety_list",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
          {
            ...dc.coffee_country,
            field: "search2",
            label: "greenbean_country_code",
            placeholder: "greenbean_country_code",
            inputClassName: dc.searchSelectWidth,
            selectPropOption: { reloadButton: false },
          },
        ],
        listSearchSelect: [
          {
            ...dc.input,
            inputType: "input",
            field: "greenbean_name_locale",
            label: "greenbean_name_locale",
            placeholder: "greenbean_name_locale",
          },
          { ...dc.input, inputType: "input", field: "greenbean_name", label: "greenbean_name", placeholder: "greenbean_name" },
          // { ...dc.input, inputType: "input", field: "search_type3", label: "greenbean_nick_locale", placeholder: "greenbean_nick_locale" },
          // { ...dc.input, inputType: "input", field: "search_type2", label: "greenbean_nick", placeholder: "greenbean_nick" },
        ],
        listOrder: [
          "greenbean_name_locale_orderasc",
          "greenbean_name_locale_orderdesc",
          // "greenbean_name_orderasc",
          // "greenbean_name_orderdesc",
          // "greenbean_nick_locale_orderdesc",
          // "greenbean_nick_locale_orderasc",
          // "greenbean_nick_orderdesc",
          // "greenbean_nick_orderasc",
        ],
        listCount: true,
        listCols: [
          params?.locale === enLocale ? "greenbean_name" : "greenbean_name_locale",
          //params?.locale !== enLocale ? "greenbean_name_locale" : "greenbean_name",
          { field: "greenbean_country_code", codeGroup: "CNTR" },
          { field: "greenbean_grade_detail", label: "grade_detail_label", codeGroup: "BQLT" },
          { field: "greenbean_variety_list", codeGroup: "VRT", inputDirect: "greenbean_variety_etc", selectProp: { mode: "multiple" } },
          { field: "greenbean_process", codeGroup: "PRCS", inputDirect: "greenbean_process_etc" },
        ],
        mobileHidden: ["greenbean_country_code", "greenbean_grade_detail", "greenbean_variety_list", "greenbean_process"],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"greenbean_roasteryear","system_table_pk":["roaster_seq","greenbean_year","greenbean_roaster_seq"],"system_table_page":"RoasterGreenbeanYear","system_table_path":"roaster/greenbean/year","system_table_page_name":"RoasterGreenbeanYear","system_table_auth":["SADMIN","ADMIN","USER","ROASTER"],"system_select_auth":["roaster"],"system_roaster_auth":"SAST","system_roaster_auth_field":["greenbean_user_auth"],"system_table_mapper":"roaster","system_table_detail_result":"detail_result","system_table_search_column":["greenbean_year","greenbean_process","greenbean_variety_list","greenbean_country_code"],"system_table_search_select":["greenbean_name_locale","greenbean_name","greenbean_nick_locale","greenbean_nick"],"system_table_order_column":["greenbean_year","greenbean_name_locale","greenbean_country_code"],"system_table_default_name_column":"greenbean_name_locale","system_table_en_name_column":"greenbean_name","system_table_use_column":"greenbean_use"},
    //--info--"change":{"greenbean_variety_list":{"COLUMN_CODE_SELECT":"VRT"},"greenbean_grade":{"COLUMN_CODE_SELECT":"BGRD"},"greenbean_grade_detail":{"COLUMN_CODE_SELECT":"BQLT"}}
    //--info--}
    case "RoasterGreenbeanYear":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/greenbean/year/detail/", saveFetch: { fetchUrl: "/api/roaster/greenbean/year/edit" } },
        listFetch: { fetchUrl: "/api/roaster/greenbean/year/list" },
        dataResultName: "detail_result",
        dataName: "RoasterGreenbeanYearData",
        dataInit: (data: any) => {
          linkInit();
        },
        dataCols: {
          greenbean_year: { ...dc.year, required: true },
          greenbean_roaster_seq: {
            // required: true,
            ...dc.selectSearch,
            update: { disabled: true },
            create: { dataProp: { firstReload: true } },
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/roaster/greenbean/default/code",
            // dataProp: {
            //   load: (data, select_data) => {
            //     Debug(data, select_data);
            //   },
            // },
            widthFull: true,
            dataLabel: {
              value: "greenbean_roaster_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "greenbean_name", subs: "greenbean_nick" }
                  : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
              ],
              labelSort: true,
            },
            onChange: (data) => {
              // const selectData = runFormFunction(formFunction?.current, "greenbean_default_seq", "selectData");
              // Debug(selectData, formMemo?.current["greenbean_default_seq"]);
              const result = getMatchingSelectData(form?.current, formFunction?.current, formMemo?.current, "greenbean_roaster_seq", [
                "greenbean_roaster_seq",
                "greenbean_country_seq",
                "greenbean_use",
                "edit_at",
              ]);
              //Debug(result);
              form?.current?.setFieldsValue(result);

              setTimeout(() => {
                runFormFunction(
                  formFunction?.current,
                  ["greenbean_default_seq", "greenbean_region_seq", "greenbean_farm_seq"],
                  "changeLoad",
                );
              }, dc.setTimeoutShort);
              //greenbean_region_seq, greenbean_farm_seq
            },
            placeholder: "new_regist_label",
          },
          greenbean_instock: {
            ...dc.use,
            label: "instock_label",
          },
          // greenbean_ref_year: { ...dc.year },
          // greenbean_ref_seq: { ...dc.select },
          ...defaultCols(true),
          ...dc.userInfoCols,
        },
        writeMatching: { search0: "greenbean_year" },
        listEdit: {
          field: "greenbean_instock",
          button: {
            onClick: (chageValues: any[] | undefined) => {
              listEditClickCommon(
                t,
                ta,
                dataFunction?.current,
                alertContext,
                "/api/roaster/greenbean/year/instock/update",
                params?.auth,
                "instock_list",
                chageValues,
              );
            },
          },
        },
        listColLinkField: ["greenbean_year", "greenbean_roaster_seq"],
        listSearch: [
          { ...dc.year, field: "search0", label: "greenbean_year", placeholder: "greenbean_year", inputClassName: dc.searchSelectWidth },
          {
            ...dc.process,
            field: "search1",
            label: "greenbean_process",
            placeholder: "greenbean_process",
            inputClassName: dc.searchSelectWidth,
          },
          {
            ...dc.selectSearchMulti,
            inputType: "select",
            codeGroup: "VRT",
            field: "search2",
            label: "greenbean_variety_list",
            placeholder: "greenbean_variety_list",
            inputClassName: dc.searchSelectWidth,
          },
          {
            ...dc.country,
            field: "search3",
            label: "greenbean_country_code",
            placeholder: "greenbean_country_code",
            inputClassName: dc.searchSelectWidth,
          },
        ],
        listSearchSelect: [
          // { ...dc.input, field: "search_title_all", label: "greenbean_name_locale", placeholder: "greenbean_name_locale" },
          { ...dc.input, field: "greenbean_name_locale", label: "greenbean_name_locale", placeholder: "greenbean_name_locale" },
          { ...dc.input, field: "greenbean_nick_locale", label: "greenbean_nick_locale", placeholder: "greenbean_nick_locale" },
          // { ...dc.input, field: "search_type2", label: "greenbean_name", placeholder: "greenbean_name" },
          // { ...dc.input, field: "search_type3", label: "greenbean_nick", placeholder: "greenbean_nick" },
        ],
        listOrder: [
          "greenbean_year_orderdesc",
          "greenbean_year_orderasc",
          "greenbean_name_locale_orderdesc",
          "greenbean_name_locale_orderasc",
          "greenbean_country_code_orderdesc",
          "greenbean_country_code_orderasc",
        ],
        listCols: [
          "greenbean_year",
          params?.locale === enLocale ? "greenbean_name" : "greenbean_name_locale",
          { field: "greenbean_country_code", codeGroup: "CNTR" },
          { field: "greenbean_grade_detail", label: "grade_detail_label", codeGroup: "BQLT" },
          { field: "greenbean_variety_list", codeGroup: "VRT", inputDirect: "greenbean_variety_etc", selectProp: { mode: "multiple" } },
          { field: "greenbean_process", codeGroup: "PRCS", inputDirect: "greenbean_process_etc" },
          { ...dc.listUse, field: "greenbean_instock", label: "instock_label" },
        ],
        mobileHidden: ["greenbean_country_code", "greenbean_grade_detail", "greenbean_variety_list", "greenbean_process"],
        clipboard: commonClipboard,
      };

    default:
      return undefined;
  }
};
